import { api } from "@/lib/api";

const SIZE_PX = { sm: 32, md: 40, lg: 48 } as const;
const SIZE_CLS = { sm: "size-8", md: "size-10", lg: "size-12" } as const;

type Props = {
  photoId: number | null;
  bbox?: string | null;
  size?: keyof typeof SIZE_PX;
  className?: string;
};

export function ProductThumb({ photoId, bbox, size = "md", className }: Props) {
  const px = SIZE_PX[size];
  const sizeCls = SIZE_CLS[size];
  const base = `${sizeCls} shrink-0 rounded overflow-hidden bg-zinc-100${className ? ` ${className}` : ""}`;

  if (!photoId) return <div className={base} />;

  if (bbox) {
    const [bx, by, bw, bh] = JSON.parse(bbox) as number[];
    return (
      <div
        className={base}
        style={{
          backgroundImage:    `url(${api.photoUrl(photoId)})`,
          backgroundRepeat:   "no-repeat",
          backgroundSize:     `${(px / bw).toFixed(1)}px ${(px / bh).toFixed(1)}px`,
          backgroundPosition: `${(-bx * px / bw).toFixed(1)}px ${(-by * px / bh).toFixed(1)}px`,
        }}
      />
    );
  }

  return (
    <img
      src={api.photoUrl(photoId)}
      alt=""
      loading="lazy"
      className={`${base} object-cover`}
      onError={(e) => { e.currentTarget.style.display = "none"; }}
    />
  );
}
